import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';
import useDebouncedInputValue from '@shared/hooks/useDebouncedInputValue';
import { Dispatch, FC, SetStateAction } from 'react';

type UtmsSearchTextFieldProps = Omit<TextFieldProps<'outlined'>, 'variant'> & {
    globalFilter: string;
    setGlobalFilter: Dispatch<SetStateAction<string>>;
};

const UtmsSearchTextField: FC<UtmsSearchTextFieldProps> = ({ globalFilter, setGlobalFilter, ...props }) => {
    const { t } = useTranslation();
    const [searchBranchLocalValue, handleChangeGlobalFilter, handleClearGlobalFilter] = useDebouncedInputValue({
        state: globalFilter,
        setState: setGlobalFilter,
    });

    return (
        <TextField
            size="small"
            placeholder={`${t('search')}...`}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                    endAdornment: searchBranchLocalValue && (
                        <InputAdornment position="end">
                            <IconButton onClick={handleClearGlobalFilter} edge="end" size="small">
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}
            value={searchBranchLocalValue}
            onChange={handleChangeGlobalFilter}
            {...props}
        />
    );
};

export default UtmsSearchTextField;
